<main class="sh-page sh-corp" *ngIf="showPage">
  <!-- HERO -->
  <header class="sh-hero sh-corp__hero" [style.background-image]="content.hero.image ? 'url(' + content.hero.image + ')' : null">
    <div class="sh-hero__overlay"></div>
    <div class="sh-wrap sh-hero__inner">
      <span class="sh-eyebrow sh-eyebrow--light">{{ content.hero.eyebrow }}</span>
      <h1 class="sh-display">{{ content.hero.title }}</h1>
      <p class="sh-hero__lede">{{ content.hero.lede }}</p>
      <div class="sh-btn-row">
        <a class="sh-btn sh-btn--blue" [href]="content.hero.ctaPrimary?.href">{{ content.hero.ctaPrimary?.label }}</a>
        <a class="sh-btn sh-btn--outline-light" [href]="content.hero.ctaSecondary?.href">{{ content.hero.ctaSecondary?.label }}</a>
      </div>
    </div>
  </header>

  <!-- BUSINESS CASE -->
  <section class="sh-section">
    <div class="sh-wrap">
      <span class="sh-eyebrow">{{ content.businessCase.eyebrow }}</span>
      <h2 class="sh-corp__h2">{{ content.businessCase.title }}</h2>
      <p class="sh-lede">{{ content.businessCase.intro }}</p>

      <div class="sh-corp__callout">
        <strong>{{ content.businessCase.calloutBold }}</strong>
        <span>{{ content.businessCase.calloutNote }}</span>
      </div>

      <div class="sh-corp__stats">
        <div class="sh-corp__stat" *ngFor="let s of content.businessCase.stats">
          <span class="sh-corp__stat-value">{{ s.value }}</span>
          <span class="sh-corp__stat-label">{{ s.label }}</span>
        </div>
      </div>
    </div>
  </section>

  <!-- PROGRAM / PRICING -->
  <section class="sh-section sh-corp__program" id="corp-program">
    <div class="sh-wrap">
      <span class="sh-eyebrow">{{ content.program.eyebrow }}</span>
      <h2 class="sh-corp__h2">{{ content.program.title }}</h2>
      <p class="sh-lede">{{ content.program.intro }}</p>

      <div class="sh-corp__grid" id="corp-pricing">
        <div class="sh-corp__card" *ngFor="let p of content.program.phases; let i = index">
          <span class="sh-corp__card-num">0{{ i + 1 }}</span>
          <span class="sh-corp__card-tag">{{ p.tag }}</span>
          <h3>{{ p.title }}</h3>
          <div class="sh-corp__price">{{ p.price }}</div>
          <div class="sh-corp__price-sub">{{ p.sub }}</div>
          <ul class="sh-check-list sh-check-list--dark">
            <li *ngFor="let b of p.bullets">{{ b }}</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA BANNER -->
  <section class="sh-corp__banner">
    <div class="sh-wrap">
      <h2>{{ content.banner.title }}</h2>
      <p>{{ content.banner.text }}</p>
      <a class="sh-btn sh-btn--blue" href="#corp-contact">{{ content.banner.ctaLabel }}</a>
    </div>
  </section>

  <!-- CONTACT FORM -->
  <section class="sh-section" id="corp-contact">
    <div class="sh-wrap sh-wrap--narrow">
      <span class="sh-eyebrow">{{ content.contact.eyebrow }}</span>
      <h2 class="sh-corp__h2">{{ content.contact.title }}</h2>
      <p class="sh-lede">{{ content.contact.intro }}</p>

      <div class="sh-form-card">
        <form [formGroup]="form" class="supportForm" (ngSubmit)="onSubmit()">
          <div class="sh-form-grid">
            <label>Company Name*<input type="text" formControlName="company" />
              <span class="sh-err" *ngIf="isInvalid('company')">Please enter your company name.</span>
            </label>
            <label>Your Name*<input type="text" formControlName="name" />
              <span class="sh-err" *ngIf="isInvalid('name')">Please enter your name.</span>
            </label>
            <label>Work Email*<input type="email" formControlName="email" />
              <span class="sh-err" *ngIf="isInvalid('email')">Please enter a valid email.</span>
            </label>
            <label>Phone<input type="tel" formControlName="phone" /></label>
          </div>

          <label class="sh-block">Company Size
            <select formControlName="size">
              <option value="">Select one</option>
              <option>1–19 employees</option>
              <option>20–49 employees</option>
              <option>50–99 employees</option>
              <option>100+ employees</option>
            </select>
          </label>

          <fieldset class="sh-fieldset" formGroupName="interests">
            <legend>What are you interested in?</legend>
            <label class="sh-check-inline" *ngFor="let o of interestOptions">
              <input type="checkbox" [formControlName]="o.key" /> {{ o.label }}
            </label>
          </fieldset>

          <label class="sh-block">Anything else we should know?
            <textarea rows="4" formControlName="message"></textarea>
          </label>

          <div class="captcha-wrapper">
            <ngx-recaptcha2
              formControlName="captchaResponseControl"
              [siteKey]="siteKey"
              (ngxCaptchaCallback)="handleSuccess($event)"
              (ngxCaptchaExpired)="handleExpire()"
              (ngxCaptchaLoad)="handleLoad()"
            ></ngx-recaptcha2>
            <a href="javascript:void(0)" (click)="resetCaptcha()">
              reset
            </a>
          </div>
          <div *ngIf="isInvalid('captchaResponseControl')" class="sh-err">
            Captcha is required
          </div>

          <!-- Never use [disabled] here: site CSS can keep disabled buttons looking enabled. -->
          <button
            type="submit"
            class="sh-btn sh-btn--blue support-submit"
            [attr.aria-busy]="submitting"
          >
            <span *ngIf="submitting">Sending…</span>
            <span *ngIf="!submitting">Submit Inquiry</span>
          </button>

          <div *ngIf="success" class="alert alert-success mt-3">
            {{ content.contact.successNote || 'Form submitted successfully' }}
          </div>

          <div *ngIf="error" class="alert alert-danger mt-3">
            {{ error }}
          </div>

          <p class="sh-form-alt">{{ content.contact.disclaimer }}</p>
        </form>
      </div>
    </div>
  </section>
</main>

<div class="sh-unavailable sh-wrap" *ngIf="!showPage">
  <h2>Page not available</h2>
  <p>This page isn't enabled for this location.</p>
  <a routerLink="/" class="sh-btn sh-btn--blue">Back to Home</a>
</div>
